import * as React from "react";
import { ArrowUpRight, Clock, MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function OurOperationsHub() {
  return <section data-section-id="223792" id="our-location" className="bg-background text-foreground relative w-full min-h-[650px] flex items-center overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/canberra_sydney_bureau_map.png)] bg-cover bg-center opacity-20 grayscale contrast-150 mix-blend-multiply"></div>
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-5"></div>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent w-full md:w-2/3 lg:w-1/2"></div>
      </div>

      {}
      <div className="absolute top-[45%] right-[10%] lg:right-[25%] hidden md:flex flex-col items-center z-10 animate-pulse">
        <div className="relative">
          <MapPin className="size-14 text-primary drop-shadow-[0_0_10px_rgba(15,23,42,0.3)]" fill="currentColor" />
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-5 h-1.5 bg-primary/20 blur-[2px] rounded-lg"></div>
        </div>
        <div className="mt-3 px-3 py-1.5 bg-primary backdrop-blur-sm border border-border rounded-lg text-xs font-mono text-primary-foreground shadow-md tracking-widest">
          AIB HQ
        </div>
      </div>

      {}
      <div className="container relative z-20 px-4 py-12 md:py-24">
        <Card className="w-full max-w-md bg-card/95 backdrop-blur-md border-border shadow-xl rounded-lg overflow-hidden">
          {}
          <div className="h-1 w-full bg-primary"></div>
          
          <CardHeader className="pb-6 pt-8">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-muted text-primary mb-5 border border-border">
              <Navigation className="size-6" />
            </div>
            <CardTitle className="font-default text-3xl font-bold tracking-tighter">
              Bureau Headquarters
            </CardTitle>
            <CardDescription className="font-default text-base text-muted-foreground mt-2">
              Independent research facilities providing national economic oversight from Australia's administrative heart.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-6 pb-8">
            <div className="flex gap-4 items-start">
              <div className="mt-0.5 bg-muted rounded-lg p-2.5 shrink-0 border border-border">
                <MapPin className="size-4 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground text-sm uppercase tracking-widest mb-1">
                  Primary Office
                </h4>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  The Australian Index Bureau (AIB)<br />
                  Canberra, ACT
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="mt-0.5 bg-muted rounded-lg p-2.5 shrink-0 border border-border">
                <Clock className="size-4 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground text-sm uppercase tracking-widest mb-1">
                  Bureau Hours
                </h4>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  Mon - Fri: 09:00 - 17:30 AEST<br />
                  Media Inquiries: 24/7
                </p>
              </div>
            </div>
          </CardContent>
          
          <CardFooter className="pt-0 pb-8">
            <Button asChild className="w-full h-12 text-base font-semibold rounded-lg shadow-sm hover:bg-primary/90 transition-all duration-200">
              <Link to="/ContactPage">
                Get Directions
                <ArrowUpRight className="size-5 ml-2" />
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}